<template>
  <v-card class="doorphone-form-card" flat outlined>
    <div class="doorphone-form-card__title">
      <v-icon left>mdi-domain</v-icon>
      <span>Данные домофона</span>
    </div>
    <v-form ref="formAddDoorphone" v-model="valid" lazy-validation>
      <v-card-text class="doorphone-form-card__content">
        <v-row>
          <v-col cols="12" md="5" class="doorphone-form-col">
            <!-- Адрес и подъезд -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Адрес и подъезд</div>
              <v-combobox
                v-model="formDoorphone.address"
                @keyup="startTypingTimer"
                @input="updateAddressSearch"
                :rules="rules.required"
                :items="addresses"
                item-text="addresses"
                prepend-inner-icon="mdi-rename-box-outline"
                :search-input.sync="searchAddress"
                return-object
                flat
                required
                label="Адрес"
                outlined
                dense
                hide-details
                class="mb-3"
              />
              <v-text-field
                label="Номер подъезда"
                v-model="formDoorphone.entrance"
                :rules="rules.requiredNumber"
                prepend-inner-icon="mdi-home-modern"
                type="number"
                outlined
                dense
                flat
                required
                hide-details
                class="mb-3"
              />
              <v-autocomplete
                label="Район (только для г. Саранск)"
                :items="district"
                :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
                item-value="id"
                prepend-inner-icon="mdi-map-marker-radius-outline"
                v-model="formDoorphone.region"
                outlined
                :disabled="!isDistrict"
                dense
                flat
                clearable
                hide-details
                class="mb-3"
              />
            </div>

            <!-- Диапазон квартир -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Диапазон квартир</div>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    label="От квартиры"
                    v-model="formDoorphone.fromApartment"
                    :rules="rules.requiredNumber"
                    prepend-inner-icon="mdi-arrow-down-bold-box-outline"
                    type="number"
                    outlined
                    dense
                    flat
                    required
                    hide-details
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="До квартиры"
                    v-model="formDoorphone.toApartment"
                    :rules="rules.requiredNumber"
                    prepend-inner-icon="mdi-arrow-up-bold-box-outline"
                    type="number"
                    outlined
                    dense
                    flat
                    required
                    hide-details
                  />
                </v-col>
              </v-row>
            </div>

            <!-- Оплата и приложение -->
            <div class="doorphone-form-section" v-if="!formDoorphone.oldIntercom">
              <div class="doorphone-form-section__label">Оплата и приложение</div>
              <v-autocomplete
                label="Оплата мобильного приложения"
                :items="creatureDoorphonePaymentTypes"
                v-model="paymentType"
                :rules="rules.required"
                prepend-inner-icon="mdi-credit-card-outline"
                item-text="payment_type"
                item-value="id"
                outlined
                dense
                flat
                :required="!formDoorphone.oldIntercom"
                hide-details
                class="mb-3"
              />
              <v-autocomplete
                label="Бесплатные ключи"
                :items="freeKeys"
                v-model="formDoorphone.free_keys"
                :rules="rules.required"
                prepend-inner-icon="mdi-cloud-key-outline"
                item-text="text"
                item-value="id"
                clearable
                outlined
                dense
                flat
                :required="!formDoorphone.oldIntercom"
                hide-details
                class="mb-3"
              />
              <v-autocomplete
                label="Выдача бесплатных ключей"
                :items="issuanceFreeKeys"
                v-model="formDoorphone.issuance_free_keys"
                prepend-inner-icon="mdi-account-key-outline"
                item-text="text"
                item-value="id"
                clearable
                outlined
                dense
                flat
                required
                hide-details
                class="mb-3"
              />
            </div>

            <!-- Управляющая компания -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Управляющая компания</div>
              <v-autocomplete
                label="Управляющая компания"
                :items="managementCompanies"
                item-text="name"
                item-value="id"
                prepend-inner-icon="mdi-home-account"
                v-model="formDoorphone.managementCompany"
                @change="setGroupManagement"
                outlined
                dense
                flat
                clearable
                hide-details
                class="mb-3"
              />
              <v-text-field
                label="Компания-собственник"
                v-model="formDoorphone.groupManagement"
                prepend-inner-icon="mdi-shield-account"
                outlined
                dense
                flat
                disabled
                hide-details
                class="mb-3"
              />
            </div>

            <!-- Тарифы и договор -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Тарифы и договор</div>
              <v-text-field
                label="Тариф за услугу «Домофон»"
                v-model="formDoorphone.tariff"
                prepend-inner-icon="mdi-currency-usd"
                outlined
                dense
                flat
                required
                type="text"
                suffix="руб. в месяц"
                hide-details
                class="mb-3"
              />
              <v-select
                label="Оплата за услугу домофон"
                :items="contractTypes"
                v-model="formDoorphone.contract_type"
                prepend-inner-icon="mdi-file-document-edit-outline"
                item-text="contract_type"
                item-value="id"
                clearable
                outlined
                dense
                flat
                required
                hide-details
                class="mb-3"
              />
            </div>

            <!-- Трубка -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Установка трубки</div>
              <v-autocomplete
                label="Возможность установки трубки"
                :items="tubeInstallation"
                item-text="name"
                prepend-inner-icon="mdi-phone-hangup"
                item-value="id"
                v-model="formDoorphone.installationTube"
                @change="setInstallationTube"
                outlined
                dense
                flat
                hide-details
                class="mb-3"
              />
              <v-text-field
                label="Стоимость установки трубки"
                v-model="formDoorphone.phone_setup_cost"
                type="number"
                prepend-inner-icon="mdi-cash-100"
                :disabled="isPhoneSetupCost"
                outlined
                dense
                flat
                required
                hide-details
                class="mb-3"
              />
            </div>

            <!-- Тип домофона и устройство -->
            <div class="doorphone-form-section">
              <div class="doorphone-form-section__label">Тип домофона</div>
              <v-checkbox
                :disabled="formDoorphone.oldIntercom"
                label="Домофон без устройства (ожидает монтажа)"
                class="pt-0 mt-0"
                v-model="formDoorphone.withoutDevice"
                @click="selectedDevices = []"
                hide-details
                dense
              />
              <v-checkbox
                :disabled="formDoorphone.withoutDevice"
                label="Старый домофон"
                class="pt-0 mt-0"
                v-model="formDoorphone.oldIntercom"
                @click="selectedDevices = []"
                hide-details
                dense
              />
              <v-text-field
                v-if="formDoorphone.withoutDevice"
                label="Физический статус"
                v-model="formDoorphone.physicalStatus"
                prepend-inner-icon="mdi-list-status"
                disabled
                outlined
                dense
                flat
                hide-details
                class="mt-2"
              />
              <v-text-field
                v-if="formDoorphone.oldIntercom"
                label="Физический статус"
                v-model="formDoorphone.physicalStatusOld"
                prepend-inner-icon="mdi-list-status"
                disabled
                outlined
                dense
                flat
                hide-details
                class="mt-2"
              />
              <v-autocomplete
                v-if="formDoorphone.oldIntercom"
                label="Физическое устройство (старого образца)"
                :items="oldIntercoms"
                :rules="formDoorphone.oldIntercom ? rules.required : []"
                v-model="formDoorphone.oldDeviceName"
                prepend-inner-icon="mdi-cog-outline"
                item-text="text"
                item-value="text"
                clearable
                outlined
                dense
                flat
                required
                hide-details
                class="mt-2"
              />
              <v-text-field
                v-if="formDoorphone.virtualGate"
                label="Название 1-й двери"
                v-model="formDoorphone.doorNameOne"
                prepend-inner-icon="mdi-rename-box-outline"
                outlined
                dense
                flat
                required
                hide-details
                class="mt-2"
              />
              <v-text-field
                v-if="formDoorphone.virtualGate"
                label="Название 2-й двери"
                v-model="formDoorphone.doorNameTwo"
                prepend-inner-icon="mdi-rename-box-outline"
                outlined
                dense
                flat
                required
                hide-details
                class="mt-2"
              />
            </div>

            <v-text-field
              label="Комментарий"
              v-model="formDoorphone.comment"
              prepend-inner-icon="mdi-comment-outline"
              outlined
              dense
              flat
              required
              hide-details
              class="mt-2"
            />
          </v-col>

          <v-col cols="12" md="7" class="pb-0">
            <v-card :disabled="formDoorphone.withoutDevice || formDoorphone.oldIntercom" class="doorphone-devices-card" flat outlined>
              <div class="doorphone-devices-card__title">
                <v-icon left small>mdi-devices</v-icon>
                Устройства
              </div>
              <div class="doorphone-devices-card__toolbar">
                <v-text-field
                  v-model="searchDevice"
                  label="Поиск по IP адресу"
                  dense
                  outlined
                  hide-details
                  autocomplete="off"
                  class="doorphone-devices-card__search"
                  @keyup.enter="filterDevices()"
                />
                <v-btn color="primary" class="text-none" rounded depressed @click.prevent="filterDevices">
                  <v-icon left small>mdi-magnify</v-icon>
                  Поиск
                </v-btn>
              </div>
              <v-data-table
                class="table"
                v-model="selectedDevices"
                :options.sync="universalOptions"
                :server-items-length="universalTotalDevices"
                :headers="headersDevices"
                :items="devices"
                item-key="id"
                show-select
                :footer-props="{
                  'items-per-page-options': [10, 20, 50, 100],
                }"
                :single-select="true"
                :disable-sort="true"
              />
            </v-card>
            <v-alert v-if="errorDevice" type="error" dense outlined class="mt-3">
              Выберите устройство
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="my-0" />
      <v-card-actions class="doorphone-form-card__actions">
        <v-btn color="primary" class="text-none" rounded depressed @click="validate()">
          Сохранить
        </v-btn>
        <v-btn text color="grey" class="text-none" @click.prevent="returnDoorphones()">
          Отменить
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  headersDevices, contractTypes, tubeInstallation, creatureDoorphonePaymentTypes,
  freeKeys, issuanceFreeKeys, oldIntercoms,
} from '../EditDoorphone/consts';
import watchTableOptions from '../../../mixins/watchTableOptions';

export default {
  name: 'DoorphoneForm',
  mixins: [watchTableOptions],
  data () {
    return {
      valid: true,
      searchDevice: '',
      isFirstLoading: true,
      isDistrict: false,
      searchAddress: '',
      typeOfDoorphone: {},
      contractTypes,
      tubeInstallation,
      value: '',
      serchValue: '',
      serchValueId: '',
      typeDoorphone: '',
      paymentType: '',
      creatureDoorphonePaymentTypes,
      freeKeys,
      issuanceFreeKeys,
      oldIntercoms,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      universalTotalDevices: 0,
      headersDevices,
      selectedDevices: [],
      errorDevice: false,
      isPhoneSetupCost: true,
      typingTimer: null,
      formDoorphone: {
        address: '',
        phone_setup_cost: '',
        installationTube: '',
        tariff: '',
        contract_type: '',
        entrance: '',
        fromApartment: '',
        comment: '',
        toApartment: '',
        managementCompany: '',
        groupManagement: '',
        issuance_free_keys: '',
        free_keys: '',
        virtualGate: false,
        withoutDevice: false,
        oldIntercom: false,
        oldDeviceName: '',
        physicalStatus: 'Ожидает монтажа',
        physicalStatusOld: 'Старый домофон',
        doorNameOne: '',
        doorNameTwo: '',
        region: null,
      },
      rules: {
        required: [
          v => !!v || 'Поле обязательно для заполнения',
        ],
        requiredNumber: [
          v => !!v || 'Поле обязательно для заполнения',
          v => v >= 0 || 'Введите целое число',
        ],
        conciergeNumber: [
          v => v >= 0 || 'Введите целое число',
          v => /^\d{11}$/.test(v) || 'Введите 11 цифр',
        ],
      },
      searchCity: '',
      searchStreet: '',
      searchHouse: '',
    };
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      addresses: 'Doorphone/addresses',
      district: 'Doorphone/districts',
      doorphones: 'Doorphone/doorphones',
      managementCompanies: 'ManagementCompany/managementCompanies',
      roleName: 'roleName',
    }),
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  created () {
    this.loadDevices({
      filters: { free: 1 },
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      });
    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
      newDoorphone: 'Doorphone/newDoorphone',
      getAddressSearch: 'Doorphone/getAddressSearch',
    }),
    updateAddressSearch () {
      const val = this.formDoorphone.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formDoorphone.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.formDoorphone.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    setGroupManagement (groupCompanyId) {
      const company = this.managementCompanies.find(item => item?.id === groupCompanyId);
      if ((company) && (company.management_group) && (company.management_group.name)) {
        this.formDoorphone.groupManagement = company.management_group.name;
      } else {
        this.formDoorphone.groupManagement = '';
      }
    },
    setInstallationTube (idTube) {
      const possibilityTube = this.tubeInstallation.find(item => item?.id === idTube);
      this.isPhoneSetupCost = possibilityTube.id === 'N';
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = { free: 1 };

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    validate () {
      this.errorDevice = false;
      let tempDevice = null;
      let agentDispatcherPhone = null;

      if (!this.formDoorphone.withoutDevice && !this.formDoorphone.oldIntercom) {
        if (!this.selectedDevices.length) {
          this.$flash_danger('Заполните все поля');
          this.errorDevice = true;
          this.$refs.formAddDoorphone.validate();
          return;
        } else {
          tempDevice = this.selectedDevices[0].id;
          agentDispatcherPhone = this.selectedDevices[0].agent.dispatcher_phone;
        }
      }

      if (this.$refs.formAddDoorphone.validate()) {
        const tempDoorphone = {
          payment_type: this.paymentType,
          address: this.formDoorphone.address,
          entrance: this.formDoorphone.entrance,
          without_device: this.formDoorphone.withoutDevice || this.formDoorphone.oldIntercom,
        };

        if (!this.formDoorphone.withoutDevice && !this.formDoorphone.oldIntercom) {
          tempDoorphone.device_id = tempDevice;
        }

        if (this.formDoorphone.oldIntercom) {
          tempDoorphone.physical_status = 5;
          tempDoorphone.old_device_name = this.formDoorphone.oldDeviceName;
        } else if (this.formDoorphone.withoutDevice) {
          tempDoorphone.physical_status = 6;
        }

        tempDoorphone.payment_type = this.paymentType;
        tempDoorphone.comment = this.formDoorphone.comment;
        tempDoorphone.tariff = this.formDoorphone.tariff;
        tempDoorphone.contract_type = this.formDoorphone.contract_type;
        tempDoorphone.free_keys = this.formDoorphone.free_keys;
        tempDoorphone.issuance_free_keys = this.formDoorphone.issuance_free_keys;

        if (this.formDoorphone.fromApartment) {
          tempDoorphone.diapason_from = this.formDoorphone.fromApartment;
        }
        if (this.formDoorphone.region && this.isDistrict) {
          tempDoorphone.region_id = this.formDoorphone.region;
        }
        if (this.formDoorphone.toApartment) {
          tempDoorphone.diapason_to = this.formDoorphone.toApartment;
        }
        if (agentDispatcherPhone) {
          tempDoorphone.concierge_number = agentDispatcherPhone;
        }

        if (this.formDoorphone.installationTube) {
          tempDoorphone.possibility_phone_setup = this.formDoorphone.installationTube;
        }

        if (this.formDoorphone.installationTube !== 'N') {
          tempDoorphone.phone_setup_cost = this.formDoorphone.phone_setup_cost;
        }

        if (this.formDoorphone.managementCompany) {
          tempDoorphone.management_company_id = this.formDoorphone.managementCompany;
        }

        if (this.formDoorphone.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.newDoorphone(tempDoorphone)
            .then(() => {
              this.$router.push({ name: 'Doorphone' });
              this.$flash_success('Домофон успешно создан');
            }).catch((error) => {
              this.$sentry_exception(error);
              this.$flash_warning('Ошибка при добавлении домофона');
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
    returnDoorphones () {
      this.$router.push({ name: 'Doorphone' });
    },
  },
};
</script>

<style lang="scss" scoped>
.doorphone-form-card {
  border-radius: 12px;
  overflow: hidden;
}

.doorphone-form-card__title {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #5a7a9e 0%, #4a6a8e 100%);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 600;
}

.doorphone-form-card__content {
  padding: 20px !important;
}

.doorphone-form-section {
  margin-bottom: 20px;
}

.doorphone-form-section__label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #546e7a;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.doorphone-devices-card {
  border-radius: 12px;
}

.doorphone-devices-card__title {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #37474f;
  background: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.doorphone-devices-card__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  flex-wrap: wrap;
}

.doorphone-devices-card__search {
  max-width: 260px;
  flex: 1;
  min-width: 180px;
}

.doorphone-form-card__actions {
  padding: 16px 20px !important;
  border-top: 1px solid #eee;
}
</style>
